import { config } from '@iheartjane/config';
import type { GeoCoordinates } from '@iheartjane/data-access';
import { AddressAutocomplete } from '@iheartjane/menu';
import { useEffect } from 'react';

import { DEFAULT_LOCATION_COORDINATES } from '@jane/search/util';
import { useUserPreferences } from '@jane/shared-ecomm/providers';
import type { StoreFulfillmentTypes } from '@jane/shared/types';

import { AddressInputWrapper } from './userPreferencesModal.styles';

export const UserPreferencesLocation = ({
  handleSetAddress,
  geoCoordinates,
  fulfillmentType,
}: {
  fulfillmentType?: StoreFulfillmentTypes;
  geoCoordinates?: GeoCoordinates;
  handleSetAddress: (address: string) => void;
}) => {
  const { userLocation } = useUserPreferences();

  const initialAddress = [
    userLocation?.street,
    userLocation?.cityState,
    userLocation?.zipcode,
  ]
    .filter(Boolean)
    .join(', ');

  const geoCoordinatesAddress = [
    geoCoordinates?.city,
    geoCoordinates?.region_code,
    geoCoordinates?.postal_code,
  ]
    .filter(Boolean)
    .join(', ');

  const handleOnSelection = (address: string) => {
    handleSetAddress(address);
  };

  // Address from localStorage first, then ip address lookup, then default location
  const defaultAddress = userLocation.cityState
    ? initialAddress
    : geoCoordinates
      ? geoCoordinatesAddress
      : DEFAULT_LOCATION_COORDINATES.cityState;

  useEffect(() => {
    handleSetAddress(defaultAddress);
  }, [defaultAddress]);

  return (
    <AddressInputWrapper flexDirection="column">
      <AddressAutocomplete
        aria-label="user location"
        clearIcon
        defaultValue={defaultAddress}
        disableMobileInputStyling
        googlePlacesKey={config.googlePlacesKey}
        locationIcon
        name="user-location"
        onSelection={handleOnSelection}
        placeholder={
          fulfillmentType === 'pickup'
            ? 'Enter city, address, etc.'
            : 'Enter delivery address'
        }
      />
    </AddressInputWrapper>
  );
};
